(function () {
  function initializeCategorySwipers() {
    if (typeof Swiper === 'undefined') {
      console.warn('Swiper library is not loaded.');
      return;
    }

    document
      .querySelectorAll('.custom-category-swiper-section')
      .forEach(function (section) {
        const swiperElement = section.querySelector('.category-swiper');
        const skeleton = section.querySelector('.category-skeleton-loader');

        if (!swiperElement || swiperElement.dataset.initialized === 'true') {
          return;
        }

        const slides = swiperElement.querySelectorAll('.swiper-slide');
        const enableLoop = slides.length > 5;

        const previousButton = section.querySelector('.swiper-button-prev');
        const nextButton = section.querySelector('.swiper-button-next');

        swiperElement.dataset.initialized = 'true';

        const showSlider = function () {
          if (skeleton) {
            skeleton.style.display = 'none';
          }

          swiperElement.style.display = 'block';
        };

        /*
         * Only wait for the first visible image.
         * Waiting for every lazy image delays LCP.
         */
        const firstImage = swiperElement.querySelector(
          '.swiper-slide:first-child img'
        );

        if (!firstImage || firstImage.complete) {
          showSlider();
        } else {
          firstImage.addEventListener('load', showSlider, { once: true });
          firstImage.addEventListener('error', showSlider, { once: true });
        }

        const swiperOptions = {
          slidesPerView: 'auto',
          centeredSlides: true,
          spaceBetween: 20,
          loop: enableLoop,
          watchOverflow: true,
          observer: true,
          observeParents: true,
          lazyPreloadPrevNext: 1,

          autoplay: {
            delay: 3000,
            disableOnInteraction: false,
            pauseOnMouseEnter: true
          },

          breakpoints: {
            0: {
              slidesPerView: 'auto',
              centeredSlides: true
            },
            640: {
              slidesPerView: 'auto',
              centeredSlides: true
            },
            768: {
              slidesPerView: 3,
              centeredSlides: false
            },
            1024: {
              slidesPerView: 5,
              centeredSlides: false
            }
          },

          on: {
            init: function () {
              /*
               * The slider may have initially been display:none,
               * so update its measurements after it becomes visible.
               */
              requestAnimationFrame(() => {
                this.update();
              });
            }
          }
        };

        if (previousButton && nextButton) {
          swiperOptions.navigation = {
            nextEl: nextButton,
            prevEl: previousButton
          };
        }

        const swiper = new Swiper(swiperElement, swiperOptions);

        // Preserve existing behavior: autoplay only below 768px.
        if (window.innerWidth >= 768 && swiper.autoplay) {
          swiper.autoplay.stop();
        }

        // Preserve existing behavior: hide arrows with five or fewer cards.
        if (!enableLoop) {
          if (previousButton) previousButton.style.display = 'none';
          if (nextButton) nextButton.style.display = 'none';
        }
      });
  }

  if (document.readyState === 'loading') {
    document.addEventListener(
      'DOMContentLoaded',
      initializeCategorySwipers,
      { once: true }
    );
  } else {
    initializeCategorySwipers();
  }

  /*
   * Reinitialize when Shopify adds/reloads a section
   * inside the Theme Editor.
   */
  document.addEventListener(
    'shopify:section:load',
    initializeCategorySwipers
  );
})();